<template>
  <v-container fluid class="pa-0">
    <v-row align="center" class="mt-n2 mb-2" dense>
      <v-col cols="12" sm="8" md="9">
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          v-model="search"
          label="Buscar envíos..."
          clearable
          dense
          outlined
          hide-details
          class="white rounded-lg"
        >
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="3" class="text-end d-flex justify-end align-center">
        <v-dialog v-model="filterDialog" width="500">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="secondary" v-bind="attrs" v-on="on" rounded small elevation="0" class="mr-2">
              <v-icon left size="18">mdi-filter-multiple</v-icon> Filtros
            </v-btn>
          </template>
          <!-- ... card content same ... -->
          <v-card>
            <v-card-title class="headline primary white--text"> Filtros </v-card-title>
            <v-card-text class="pt-4">
              <v-container>
                <!-- ... rows same ... -->
                <v-row>
                  <v-col>
                    <span> Datos de guía </span>
                    <v-autocomplete
                      v-model="form.guide"
                      :items="guideTypes"
                      label="Seleccione tipo de datos"
                      no-data-text="No hay cultivo"
                      solo
                      dense
                      clearable
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <span> Cultivo </span>
                    <v-autocomplete
                      v-model="form.cropCycle"
                      :items="crop_items"
                      label="Seleccione un cultivo"
                      no-data-text="No hay cultivo"
                      solo
                      dense
                      clearable
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <span> Tipò de muestra </span>
                    <v-autocomplete
                      v-model="form.sampleType"
                      :items="sampleType"
                      label="Seleccione tipo de muestra"
                      solo
                      no-data-text="No hay cultivo"
                      dense
                      clearable
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <span> Tipo de análisis </span>
                    <v-autocomplete
                      v-model="form.analysisType"
                      :items="analysisType"
                      label="Seleccione tipo de análisis"
                      no-data-text="No hay cultivo"
                      solo
                      dense
                      clearable
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="gray" dark @click="filterDialog = false">
                Cancelar
              </v-btn>
              <v-btn color="info" @click="cleanFilters">
                Limpiar filtros
              </v-btn>
              <v-btn color="primary" @click="applyFilters"> Aplicar </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-btn color="primary" rounded small @click="fetchData" elevation="0">
          <v-icon :left="!$vuetify.breakpoint.xsOnly"> mdi-refresh </v-icon>
          <span v-if="!$vuetify.breakpoint.xsOnly">Refrescar</span>
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="mt-n4">
      <v-col>
        <template v-if="$vuetify.breakpoint.xsOnly">
          <v-container class="pa-2 px-0 bg-app">
            <v-row dense>
              <v-col
                cols="12"
                v-for="item in shipments"
                :key="item._id"
                class="mb-2"
              >
                <v-card elevation="1" class="rounded-xl pa-4">
                  <div class="d-flex justify-space-between align-center mb-2">
                    <div class="d-flex align-center">
                      <v-avatar color="primary" size="40" class="mr-3">
                        <span class="white--text text-subtitle-1 font-weight-bold">
                          <v-icon dark>mdi-truck-delivery</v-icon>
                        </span>
                      </v-avatar>
                      <div>
                        <div class="text-subtitle-1 font-weight-bold grey--text text--darken-4 line-height-tight">
                          {{ item.field_advisor }}
                        </div>
                        <div class="text-caption grey--text text--darken-1">
                          {{ item.distributor }}
                        </div>
                      </div>
                    </div>
                    <v-btn
                      icon
                      small
                      @click="toggleMobileExpand(item._id)"
                    >
                      <v-icon>{{ mobileExpandedIds.includes(item._id) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </v-btn>
                  </div>

                  <v-divider class="my-2"></v-divider>

                  <v-row dense class="text-caption">
                    <v-col cols="6" class="py-1">
                      <div class="grey--text">Fecha de Envío</div>
                      <div class="font-weight-medium">
                        {{ getDateFormatted(item.request_date) }}
                      </div>
                    </v-col>
                    <v-col cols="6" class="py-1">
                      <div class="grey--text d-flex align-center">
                        Estado de Guía
                        <v-icon
                          size="16"
                          class="ml-2"
                          color="primary"
                          @click="openGuideModel(item)"
                          v-if="
                            authenticatedUser &&
                            authenticatedUser.permission &&
                            authenticatedUser.permission.updateGuide
                          "
                        >
                          mdi-map-marker-path
                        </v-icon>
                      </div>
                      <div class="font-weight-medium mt-1">
                        <v-chip
                          small
                          :color="item.status === 'WITH_DATA' ? 'primary' : item.status === 'PARTIAL_DATA' ? 'blue' : 'info'"
                          text-color="white"
                          class="font-weight-bold px-2"
                          style="height: 20px;"
                        >
                          {{ item.status === 'WITH_DATA' ? 'Completado' : item.status === 'PARTIAL_DATA' ? 'Parcial' : 'Faltante' }}
                        </v-chip>
                      </div>
                    </v-col>
                    <v-col cols="6" class="py-1">
                      <div class="grey--text">Email</div>
                      <div class="font-weight-medium text-truncate">
                        {{ item.email || 'No especificado' }}
                      </div>
                    </v-col>
                    <v-col cols="6" class="py-1">
                      <div class="grey--text">Código postal</div>
                      <div class="font-weight-medium">
                        {{ item.postal_code || 'No especificado' }}
                      </div>
                    </v-col>
                    <v-col cols="6" class="py-1">
                      <div class="grey--text">Número de muestras</div>
                      <div class="font-weight-medium">
                        {{ item.samples_number }}
                      </div>
                    </v-col>
                  </v-row>

                  <!-- Expanded Mobile View -->
                  <v-expand-transition>
                    <div v-show="mobileExpandedIds.includes(item._id)" class="mt-4 pt-4 border-top">
                      <div class="text-subtitle-2 font-weight-bold mb-2 primary--text">Muestras del Envío</div>
                      <div v-for="(content, idx) in item.content" :key="idx" class="mb-3 grey lighten-4 pa-2 rounded-lg">
                        <div class="font-weight-bold grey--text text--darken-3 mb-1">{{ content.folio }}</div>
                        <div class="text-caption">
                          <span class="grey--text">Cultivo:</span> {{ getCrop(content.crop) }}<br/>
                          <span class="grey--text">Muestra:</span> {{ content.sampleType }} {{ getSampleType(content.type) }}
                        </div>
                      </div>
                    </div>
                  </v-expand-transition>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </template>
        <v-data-table
          v-else
          width="100%"
          :height="$vuetify.breakpoint.smAndDown ? 'auto' : `calc(100vh - 380px)`"
          :headers="headers"
          :items="shipments"
          fixed-header
          :items-per-page="10"
          no-data-text="No hay muestras en tránsito o que coincidan con la búsqueda"
          loading-text="Cargando muestras en tránsito..."
          :page.sync="page"
          hide-default-footer
          :loading="fetchingData"
          show-expand
          item-key="_id"
          :single-expand="true"
          :expanded.sync="expanded"
        >
          <template v-slot:item.data-table-expand="{ isExpanded, expand }">
            <v-icon
              @click="expand(!isExpanded)"
              color="grey darken-1"
            >
              {{ isExpanded ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
            </v-icon>
          </template>
          <template v-slot:item.request_date="{ item }">
            <span class="grey--text text--darken-2">{{ getDateFormatted(item.request_date) }}</span>
          </template>
          <template v-slot:item.field_advisor="{ item }">
            {{ item.field_advisor }}
          </template>
          <template v-slot:item.distributor="{ item }">
            {{ item.distributor }}
          </template>
          <template v-slot:item.email="{ item }">
            {{ item.email || 'No especificado' }}
          </template>
          <template v-slot:item.postal_code="{ item }">
            {{ item.postal_code || 'No especificado' }}
          </template>
          <template v-slot:item.samples_number="{ item }">
            {{ item.samples_number }}
          </template>
          <template v-slot:item.guide="{ item }">
            <v-icon
              @click="openGuideModel(item)"
              class="mr-2"
              v-if="
                authenticatedUser &&
                authenticatedUser.permission &&
                authenticatedUser.permission.updateGuide
              "
            >
              mdi-map-marker-path
            </v-icon>
            <v-icon v-else class="mr-2"> mdi-map-marker-path </v-icon>

            <v-chip
              small
              :color="item.status === 'WITH_DATA' ? 'primary' : item.status === 'PARTIAL_DATA' ? 'blue' : 'info'"
              text-color="white"
              class="font-weight-bold px-3 ml-2"
            >
              {{ item.status === 'WITH_DATA' ? 'Completado' : item.status === 'PARTIAL_DATA' ? 'Parcial' : 'Faltante' }}
            </v-chip>
          </template>
          <template v-slot:expanded-item="{ headers: expandedHeaders, item }">
            <td :colspan="expandedHeaders.length" class="px-0 py-2 grey lighten-5">
              <v-data-table
                :headers="headersChild"
                :items="item.content"
                hide-default-footer
                elevation="0"
                class="transparent mx-4"
              >
                <template #[`item.crop`]="{ item: slotItem }">
                  {{ getCrop(slotItem.crop) }}
                </template>
                <template #[`item.sampleType`]="{ item: slotItem }">
                  {{ slotItem.sampleType }} {{ getSampleType(slotItem.type) }}
                </template>
              </v-data-table>
            </td>
          </template>
        </v-data-table>
        <v-pagination
          v-model="page"
          :length="numPages"
          total-visible="10"
          color="primary"
          class="mt-n2"
        ></v-pagination>
      </v-col>
    </v-row>
    <v-row class="text-center" v-if="showFetchingDataButton">
      <v-col>
        <v-btn color="primary" rounded @click="fetchData"
          ><v-icon>mdi-refresh</v-icon></v-btn
        >
      </v-col>
    </v-row>
    <GuideModal v-model="showGuideModal" @updateTable="fetchData"  v-if="showGuideModal" />
  </v-container>
</template>

<script>
//Vuex
import { mapActions, mapState, mapMutations } from "vuex";
//Libraries
import dayjs from "dayjs";
//axios
import axios from "axios";
//components
import GuideModal from "@/components/reception/modals/GuideModal";
export default {
  components: {
    GuideModal,
  },
  data: () => ({


    shipments: [],
    fetchingData: false,
    page: 1,
    numPages: 0,
    search: null,
    showFetchingDataButton: false,
    filterDialog: false,
    crop_items: [],
    sampleType: [
      {
        text: "Suelo compuesto",
        value: "CLASSIC",
      },
      {
        text: "Vegetal",
        value: "MAS_VEGETABLE",
      },
      {
        text: "Vegetal sin georeferencia",
        value: "VEGETABLE",
      },
      {
        text: "Composta",
        value: "COMPOST",
      },
      {
        text: "Producto",
        value: "PRODUCT",
      },
      {
        text: "Sustrato",
        value: "SUBSTRATUM",
      },
      {
        text: "Suelo sin asesor",
        value: "NO_ADVISOR",
      },
      {
        text: "Suelo compuesto",
        value: "CLASSIC",
      },
    ],
    analysisType: [
      {
        text: "Inicial",
        value: "INITIAL",
      },
      {
        text: "Seguimiento",
        value: "MONITORING",
      },
    ],
    sampleStatus: [
      {
        text: "Muestreada",
        value: "VALIDATED",
      },
      {
        text: "Muestreo en progreso",
        value: "IN_PROGRESS",
      },
    ],
    guideTypes: [
      {
        text: "Sin datos de guía",
        value: "NOT_DATA",
      },
      {
        text: "Datos parciales de guía",
        value: "PARTIAL_DATA",
      },
      {
        text: "Con datos de guía",
        value: "WITH_DATA",
      },
    ],
    form: {
      cropCycle: null,
      sampleType: null,
      analysisType: null,
    },
    showGuideModal: false,
    expanded: [],
    mobileExpandedIds: [],
    user: JSON.parse(localStorage.getItem("user")),
  }),
  async mounted() {
    this.setCropItems();
    await this.fetchData();
  },
  computed: {
    ...mapState("reception", ["crops"]),
    ...mapState(["cancelToken"]),
    ...mapState("session", ["authenticatedUser"]),
    headers() {
      return [
        { text: "Fecha de petición", value: "request_date", sortable: false },
        { text: "Asesor de campo", value: "field_advisor", sortable: false },
        { text: "Empresa asociada", value: "distributor", sortable: false },
        { text: "Email", value: "email", sortable: false },
        { text: "Codigo postal", value: "postal_code", align: "center", sortable: false },
        { text: "Número de muestras", value: "samples_number", align: "center", sortable: false },
        { text: "Guía de paqueteria", value: "guide", align: "center", sortable: false },
      ];
    },
    headersChild() {
      return [
        { text: "Contenedor", value: "code", sortable: false },
        { text: "Cultivo", value: "crop", sortable: false },
        { text: "Nombre unidad de riego", value: "name", sortable: false },
        { text: "Tipo de muestra", value: "sampleType", sortable: false },
        { text: "# submuestras", value: "subSample", align: "center", sortable: false },
      ];
    },
  },
  methods: {
    ...mapMutations(["SET_CANCEL_TOKEN"]),
    ...mapActions("reception", ["getShipments"]),
    ...mapMutations("reception", ["SET_GUIDE", "CAN_UPDATE_GUIDE"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    async fetchData() {
      this.fetchingData = true;
      try {
        if (typeof this.cancelToken != "undefined") {
          this.cancelToken.cancel("Operation canceled due to new request.");
        }
        //Save the cancel token for the current request
        this.SET_CANCEL_TOKEN(axios.CancelToken.source());
        let payload = {
          page: this.page,
          search: this.search,
          // laboratory: this.user.laboratory._id,
          filters: this.form,
        };
        let response = await this.getShipments(payload);
        if (response) {
          if (!response.error) {
            //hide loaders
            this.fetchingData = false;
            this.showFetchingDataButton = false;
            //set sample data
            this.shipments = response.shipments;
            this.numPages = response.pages;
          } else {
            throw response;
          }
        }
      } catch (e) {
        //print log
        console.log(e);
        //hide loaders
        this.fetchingData = false;
        //show attempt button to try fetch data manually
        this.showFetchingDataButton = true;
        //show error to user
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal cargar muestras en transito, intente de nuevo !!",
          timeout: 5000,
        });
      }
    },
    getStatus(value) {
      let status = {
        IN_PROGRESS: "En proceso",
        VALIDATED: "Finalizado",
      };
      return status[value];
    },
    setCropItems() {
      let cropsArray = Object.entries(this.crops);
      for (let crop of cropsArray) {
        this.crop_items.push({
          text: crop[1],
          value: crop[0],
        });
      }
    },
    getCrop(value) {
      let template = "";
      const crop = {
        olive: "Aceituna",
        chard: "Acelga",
        achiote: "Achiote",
        agave: "Agave",
        avocado: "Aguacate",
        garlic: "Ajo",
        sesame: "Ajonjolí",
        basil: "Albahaca",
        artichoke: "Alcachofa",
        alcatraz: "Alcatraz",
        shrunkenAlfalfa: "Alfalfa achicalada",
        greenAlfalfa: "Alfalfa verde",
        cotton: "Algodón",
        almond: "Almendro",
        birdseed: "Alpiste",
        amaranth: "Amaranto",
        anise: "Anís",
        celery: "Apio",
        blueberry: "Arándano",
        myrtle: "Arrayán",
        rice: "Arroz",
        greenForageOats: "Avena forrajera en verde",
        oatGrain: "Avena grano",
        bamboo: "Bambú",
        eggplant: "Berenjena",
        beetroot: "Betabel",
        broccoli: "Brocoli",
        peanut: "Cacahuate",
        cocoa: "Cacao",
        cherryCoffee: "Café cereza",
        pumpkin: "Calabaza",
        sweetPotato: "Camote",
        sugarCane: "Caña de azúcar",
        canola: "Canola",
        carambolo: "Carambolo",
        safflower: "Cártamo",
        barley: "Cebada",
        greenForageBarley: "Cebada forrajera en verde",
        onion: "Cebolla",
        chives: "Cebollín",
        ryeGrain: "Centeno grano",
        cherry: "Cereza",
        chabacano: "Chabacano",
        pea: "Chícharo",
        squash: "Chayote",
        chia: "Chía",
        chilacayote: "Chilacayote",
        chillyPepper: "Chile / Pimiento",
        custardApple: "Chirimoya",
        coriander: "Cilantro",
        plum: "Ciruela",
        coconutFruit: "Coco fruta",
        cabbage: "Col (repollo)",
        brusselsSprouts: "Col de Bruselas",
        cauliflower: "Coliflor",
        cumin: "Comino",
        chrysanthemum: "Crisantemo (planta)",
        peach: "Durazno",
        date: "Dátil",
        greenBean: "Ejote",
        cornCob: "Elote",
        dill: "Eneldo",
        epazote: "Epazote",
        asparagus: "Espárrago",
        spicesAndMedicinals: "Especias y medicinales",
        spinach: "Espinaca",
        raspberry: "Frambuesa",
        strawberry: "Fresa",
        bean: "Frijol",
        chickpea: "Garbanzo",
        sunflower: "Girasol",
        pomegranate: "Granada",
        soursop: "Guanábana",
        guava: "Guayaba",
        henequen: "Henequén",
        peppermint: "Hierbabuena",
        aromaticHerbs: "Hierbas aromáticas",
        fig: "Higo",
        jamaica: "Jamaica",
        ginger: "Jenjibre",
        jicama: "Jícama",
        lettuce: "Lechuga",
        lentil: "Lenteja",
        lime: "Lima",
        lemon: "Limón",
        linseed: "Linaza",
        litchi: "Litchi",
        corn: "Maíz",
        macadamia: "Macadamia",
        maguey: "Maguey",
        mamey: "Mamey",
        tangerine: "Mandarina",
        mango: "Mango",
        mangosteen: "Mangostán",
        chamomile: "Manzanilla",
        appleTree: "Manzano",
        passionFruit: "Maracuyá",
        daisyFlower: "Margarita",
        marjoram: "Mejorana",
        melon: "Melón",
        quince: "Membrillo",
        mint: "Menta",
        moringa: "Moringa",
        turnip: "Nabo",
        nanche: "Nanche",
        napa: "Napa",
        orange: "Naranja",
        medlar: "Níspero",
        nochebuena: "Nochebuena (planta)",
        walnut: "Nogal",
        noni: "Noni",
        nopal: "Nopal",
        oregano: "Orégano",
        ornamental: "Ornamentales",
        orchid: "Orquídea (planta)",
        oilPalm: "Palma africana o de aceite",
        potato: "Papa",
        papaya: "Papaya",
        grasslands: "Pastizales",
        matGrass: "Pasto tapete (m2)",
        pasturesAndMeadows: "Pastos y praderas",
        cucumber: "Pepino",
        pearTree: "Peral",
        parsley: "Perejil",
        peron: "Perón",
        persimony: "Persimonio",
        pepper: "Pimienta",
        pineapple: "Piña",
        pinion: "Piñón",
        pistache: "Pistache",
        pitaya: "Pitaya",
        banana: "Plátano",
        pore: "Poro",
        radish: "Rábano",
        rambutan: "Rambután",
        romerito: "Romerito",
        rosemary: "Romero",
        aloe: "Sábila",
        watermelon: "Sandía",
        sorghum: "Sorgo",
        soy: "Soya",
        stevia: "Stevia",
        tobacco: "Tabaco",
        tamarind: "Tamarindo",
        tejocote: "Tejocote",
        tomato: "Tomate Rojo (jitomate)",
        greenTomato: "Tomate Verde",
        thyme: "Tomillo",
        grapefruit: "Toronja (pomelo)",
        clover: "Trébol",
        wheat: "Trigo",
        dutchTulip: "Tulipán holandés",
        tuna: "Tuna",
        grape: "Uva",
        vanilla: "Vainilla",
        purslane: "Verdolaga",
        vine: "Vid",
        cassavaFood: "Yuca alimenticia",
        carrot: "Zanahoria",
        sapodilla: "Zapote",
        blackberry: "Zarzamora",
        zempoalxochitl: "Zempoalxochitl",
        fallow: "Barbecho",
        other: "Otro",
      };
      let cropName = crop[value];
      if (cropName) {
        template = cropName;
      } else {
        template = "Sin cultivo";
      }
      return template;
    },
    getDateFormatted(value) {
      const date = `${dayjs(value).format("D/M/YYYY - HH:mm")} hrs`;
      return date ? date : "----";
    },
    getSampleType(value) {
      console.log(value);
      const types = {
        CLASSIC: "Suelo compuesto",
        MAS: "Muestra para genómica",
        MAS_VEGETABLE: "Vegetal",
        VEGETABLE: "Vegetal sin georeferencia",
        COMPOST: "Composta",
        PRODUCT: "Producto",
        SUBSTRATUM: "Sustrato",
        NO_ADVISOR: "Suelo sin asesor",
      };
      if (value) {
        let temp = types[value];
        return temp;
      } else {
        return "";
      }
    },
    getAnalysisType(value) {
      if (value == "INITIAL" || value == "Initial") {
        return "Inicial";
      } else {
        return "Seguimiento";
      }
    },
    async applyFilters() {
      this.filterDialog = false;
      this.page = 1;
      await this.fetchData();
    },
    async cleanFilters() {
      this.search = null;
      this.filterDialog = false;
      this.form = {
        cropCycle: null,
        sampleType: null,
        analysisType: null,
      };
      await this.fetchData();
    },
    openGuideModel(value) {
      this.CAN_UPDATE_GUIDE(true);
      this.SET_GUIDE(value);
      this.showGuideModal = true;
    },
    toggleMobileExpand(id) {
      const idx = this.mobileExpandedIds.indexOf(id);
      if (idx === -1) {
        this.mobileExpandedIds.push(id);
      } else {
        this.mobileExpandedIds.splice(idx, 1);
      }
    },
  },
  watch: {
    async search() {
      this.page = 1;
      await this.fetchData();
    },
    async page() {
      //   if (this.page != parseInt(this.$route.params.page)) {
      //   this.$router.replace({
      //     params: {
      //       page: this.page,
      //     },
      //   });
      // }
      await this.fetchData();
    },
  },
};
</script>

<style scoped>
</style>